export type QuoteDirection = "INCOMING" | "OUTGOING";

export interface QuoteDirectionCounts {
  incomingCount: number;
  outgoingCount: number;
}

/**
 * Picks the quote direction a project view should select on initial entry.
 *
 * Outgoing wins whenever it is available and populated, so a project with
 * outgoing quotes - with or without incoming ones - keeps its previous
 * behavior. Incoming is only selected automatically when it is the single
 * populated direction. When neither direction has quotes the first available
 * direction is used, preferring Outgoing.
 *
 * The counts must be the project's unfiltered totals so that search terms,
 * quick filters or pagination never move the selection.
 */
export const selectInitialQuoteDirection = (
  availableDirections: readonly QuoteDirection[],
  { incomingCount, outgoingCount }: QuoteDirectionCounts
): QuoteDirection | undefined => {
  const isAvailable = (direction: QuoteDirection) =>
    availableDirections.includes(direction);

  if (isAvailable("OUTGOING") && outgoingCount > 0) return "OUTGOING";
  if (isAvailable("INCOMING") && incomingCount > 0) return "INCOMING";
  if (isAvailable("OUTGOING")) return "OUTGOING";
  if (isAvailable("INCOMING")) return "INCOMING";

  return undefined;
};
